module.exports = __webpack_public_path__ + "static/media/icons_Bilan des chaînes physiologiques.b69fe28c.svg";